module.exports = __webpack_public_path__ + "media/images/checkbox_unchecked-e61986ea2d4ce59cc8201d92c4131aa8.svg";